import React from 'react';
import MediaPlayListContainer from 'containers/MediaPlayListContainer/MediaPlayListContainer';

export default function MediaPlayListPage() {
    return (
        <MediaPlayListContainer />
    )
}
